import { Component, OnInit } from '@angular/core';
import {BankTransferLoadService} from '../../../bank-transfer-load.service';
import {Upload} from '../../../dto/upload';
import {DatePipe, Location} from '@angular/common';
import {FileHelper} from '../../../helpers/file-helper';
import {ToastService} from 'angular-toastify';

@Component({
  selector: 'app-last-load-files',
  templateUrl: './last-load-files.component.html',
  styleUrls: ['./last-load-files.component.css']
})
export class LastLoadFilesComponent implements OnInit {
  lastFiles: Upload[];
  isLoading: boolean;

  constructor(
    private bankTransferLoadService: BankTransferLoadService,
    private location: Location,
    private datePipe: DatePipe,
    private _toastService: ToastService,
  ) { }

  ngOnInit() {
    this.bankTransferLoadService.getLastLoadFiles().subscribe(
      files => this.lastFiles = files
    );

  }

  returnBack() {
    this.location.back();
  }


  downloadFile(fileId: number) {
    this.bankTransferLoadService.getFile( fileId ).subscribe(
      result => {
        FileHelper.saveFile( result );
      },
      err =>
        this._toastService.error(err.error.message || err.message || err.error || err)
        /*this.snackBar.open( err.error.message || err.message || err.error || err, null, {
          duration: 5000,
          panelClass: [ "app-mat-snack-bar" ]
        } )*/
    );
  }

}
